import React, { useCallback, useEffect, useRef } from "react";
import FxmsAPP from "../fxms/FxmsApp";
import { FemsData } from "./datas/FemsData";

const FemsAPP = (props) => {
  const [init, setInit] = React.useState(false);

  useEffect(() => {

    FemsData.initData(function (obj) {
      console.log("*** FemsAPP *** initData = ", obj);
      setInit(true);
    });

    console.log("*** FemsAPP *** uiGrpNo = ", props.uiGrpNo);
    console.log("*** FemsAPP *** init = ", init);

  }, []);

  if (init) {
    return React.createElement(FxmsAPP, props, null);
  } else {
    return "";
  }

};

export default FemsAPP;
